import gql from 'graphql-tag';

export const GET_AUTHOR = gql`
  query GetAuthor($id: ID!) {
    author(id: $id) {
      id
      name
      alternateName
      certified
      description
      mail
      mobile
      disableNotif
      prenom
      image
      imageProfil
      favorites
      uid
      deleted
    }
  }
`;

export const GET_AUTHOR_FAV = gql`
  query GetFavorites($favorites: [String]) {
    favorites(favorites: $favorites) {
      data {
        sid
        id
        title
        media
        photos
        price
        category
        certified
        town
        createdAt
        updatedAt
      }
    }
  }
`;
